import React from "react";
import "./BanarAdStyle.css";
import { Grid } from "@mui/material";

function BanarAd({ adImgUrl, adHeader, adParagraph }) {
  return (
    <Grid container className="banarAdContainer">
      <Grid
        item
        xs={12}
        sm={10}
        md={10}
        lg={10}
        className="banar-ad-img-det-container"
      >
        <img src={adImgUrl} alt="Advertiser Logo" className="boxAdImg" />
        <div className="bannar-ad-det-container">
          <p className="boxAdHeader"> {adHeader}</p>
          <p className="boxAdParagraph"> {adParagraph}</p>
        </div>
      </Grid>
      <Grid
        item
        xs={12}
        sm={2}
        md={2}
        lg={2}
        sx={{ display: "flex" }}
        justifyContent="center"
        alignItems="center"
      >
        <button
          className="more-button"
          onClick={() => {
            const phoneLink = `tel:19382`;
            window.location.href = phoneLink;
          }}
        >
          Contact Sales
        </button>
      </Grid>
    </Grid>
  );
}

export default BanarAd;
